export default "__VITE_ASSET__LuuC$Uqx__"